import React from "react"
import {Button,} from "antd";
import {IViewSetStepProps} from "./ViewConfiguration";
import View from "../../view/View";
import LocaleText from "../../settings/dictionary/LocaleText";

class ViewPreview extends React.Component<IViewSetStepProps> {
    render() {
        const {resource, match, history} = this.props

        return (
            <>
                {resource && resource.units && (
                    <View preview={true} uuid={resource.uuid} resource={resource} match={match} history={history}/>
                )}

                <Button type={"primary"} onClick={() => this.props.setStep()}><LocaleText code={'general.next-step'} fallback={'Následující krok'}/></Button>
                <Button onClick={() => this.props.setStep(true)}><LocaleText code={'general.previous-step'} fallback={'Předchozí krok'}/></Button>
            </>
        )
    }
}

export default ViewPreview